function addViewedProperty(propertyId) {
    const viewedProperties = JSON.parse(localStorage.getItem("viewedProperties")) || [];
    if (viewedProperties.includes(propertyId)) return false
    
    viewedProperties.push(propertyId);
    localStorage.setItem("viewedProperties", JSON.stringify(viewedProperties));
    return true
}

export default addViewedProperty